import React from 'react';
import { PropTypes } from 'prop-types';
import { InputGroup, Input } from 'reactstrap';

const COUNT = 'count';
const MAX_ITEMS = 100;

const NumberOfItems = ({ onDataChange, count }) => {
  function onNumbersChanged(e) {
    const { value } = e.target;

    if (value > MAX_ITEMS) {
      return;
    }
    onDataChange(COUNT, e.target.value);
  }

  return (
    <div className="row config-container align-items-center">
      <div className="config-title mr-3">
        # of items
      </div>
      <div className="mr-2">
        <InputGroup>
          <Input value={count} min={0} max={MAX_ITEMS} type="number" step="1" onChange={onNumbersChanged} />
        </InputGroup>
      </div>
      <div className="config-title mr-3">
        {`${MAX_ITEMS} max`}
      </div>
    </div>
  );
};


NumberOfItems.propTypes = {
  onDataChange: PropTypes.func,
  count: PropTypes.string
};

NumberOfItems.defaultProps = {
  onDataChange: () => { },
  count: ''
};

export default NumberOfItems;



// WEBPACK FOOTER //
// ./src/components/dashboard/list/configuration-elements/NumberOfItems.js